import { ModeSettingEnum, ScenarioSettingEnum } from '@colonist/game-base-types';
import { ArrayUtils } from '@colonist/utils';
import * as GameMode from './GameModeData.ts';
import { passThroughTranslation } from '@colonist/i18n';
import { ScenarioDataFogIsland, ScenarioDataFourIslands, ScenarioDataHeadingForNewShores, ScenarioDataNone, ScenarioDataThroughTheDesert } from './ScenarioData.ts';
export class GameModeDataController {
    static getModeDataForMode(modeSetting) {
        for (const gameModeData of GameModeDataController.privateGameModeDataList){
            if (gameModeData.modeSetting == modeSetting) return gameModeData.getNewInstanceOfData();
        }
        return undefined;
    }
    static getModeName(modeSetting) {
        var _this_getModeDataForMode;
        const gameModeText = (_this_getModeDataForMode = this.getModeDataForMode(modeSetting)) === null || _this_getModeDataForMode === void 0 ? void 0 : _this_getModeDataForMode.name;
        const defaultGameModeName = passThroughTranslation(ModeSettingEnum[modeSetting]);
        return gameModeText !== null && gameModeText !== void 0 ? gameModeText : defaultGameModeName;
    }
    static getScenarioDataForScenario(scenarioSetting) {
        const scenarioDataClass = this.scenarioDataClasses[scenarioSetting];
        return new scenarioDataClass();
    }
    static getMaxAllowablePlayerCountForMode(modeSetting) {
        const allowablePlayerCount = [];
        const availableGameModeData = GameModeDataController.getAvailableGameModeDataForTemporaryMode(modeSetting);
        for (const gameModeData of availableGameModeData){
            const allowablePlayerCountForExtension = gameModeData.getAllowablePlayerCount();
            allowablePlayerCount.push(...allowablePlayerCountForExtension);
        }
        return Math.max(...allowablePlayerCount);
    }
    static getAvailableGameModeDataForTemporaryMode(modeSetting) {
        const availableGameModeDataForTemporaryMode = [];
        const mainGameModeData = GameModeDataController.getModeDataForMode(modeSetting);
        if (mainGameModeData == undefined) return availableGameModeDataForTemporaryMode;
        const temporaryModeSetting = mainGameModeData.temporaryModeSetting;
        for (const gameModeData of GameModeDataController.privateGameModeDataList){
            if (gameModeData.temporaryModeSetting != temporaryModeSetting) continue;
            availableGameModeDataForTemporaryMode.push(gameModeData);
        }
        return availableGameModeDataForTemporaryMode;
    }
    static getAvailableExtensionsForTemporaryMode(temporaryModeSetting) {
        const availableExtensions = [];
        for (const gameModeData of GameModeDataController.privateGameModeDataList){
            if (gameModeData.temporaryModeSetting != temporaryModeSetting) continue;
            if (ArrayUtils.elementInArray(availableExtensions, gameModeData.extensionSetting)) continue;
            availableExtensions.push(gameModeData.extensionSetting);
        }
        return availableExtensions;
    }
    static getGameModeDataForPlayerCountAndMode(playerCount, modeSetting) {
        const availableExtensionsForTemporaryMode = GameModeDataController.getAvailableGameModeDataForTemporaryMode(modeSetting);
        for (const gameModeDate of availableExtensionsForTemporaryMode){
            const allowablePlayercount = gameModeDate.getAllowablePlayerCount();
            if (ArrayUtils.elementInArray(allowablePlayercount, playerCount)) return gameModeDate;
        }
        return undefined;
    }
    static isModeCitiesAndKnights(modeSetting) {
        if (modeSetting == ModeSettingEnum.CitiesAndKnights4P) return true;
        if (modeSetting == ModeSettingEnum.CitiesAndKnights56P) return true;
        if (modeSetting == ModeSettingEnum.CitiesAndKnightsSeafarers4P) return true;
        if (modeSetting == ModeSettingEnum.CitiesAndKnightsSeafarers56P) return true;
        return false;
    }
}
GameModeDataController.publicGameModeDataList = [
    new GameMode.ModeClassic4PData(),
    new GameMode.ModeColonistRushData(),
    new GameMode.ModeClassic56PData(),
    new GameMode.ModeClassic78PData(),
    new GameMode.ModeCitiesAndKnights4PData(),
    new GameMode.ModeCitiesAndKnights56PData(),
    new GameMode.ModeSeafarers4PData(),
    new GameMode.ModeSeafarers56PData(),
    new GameMode.ModeSeafarersAndCitiesAndKnights4PData(),
    new GameMode.ModeSeafarersAndCitiesAndKnights56PData(),
    new GameMode.ModeServerStressTestClassic4P()
];
GameModeDataController.privateGameModeDataList = [
    ...GameModeDataController.publicGameModeDataList,
    new GameMode.ModeClassicBeginner4PData(),
    new GameMode.ModeClassicTutorial4PData()
];
GameModeDataController.scenarioDataClasses = {
    [ScenarioSettingEnum.None]: ScenarioDataNone,
    [ScenarioSettingEnum.SS1HeadingForNewShores]: ScenarioDataHeadingForNewShores,
    [ScenarioSettingEnum.SS2TheFourIslands]: ScenarioDataFourIslands,
    [ScenarioSettingEnum.SS3TheFogIslands]: ScenarioDataFogIsland,
    [ScenarioSettingEnum.SS4ThroughTheDesert]: ScenarioDataThroughTheDesert
};
